export enum MenuItem {
  Monitoring = 'monitoring',
  Incidents = 'edr',
  MobileSecurity = 'mobileSecurity',
  InstallationPackages = 'installationPackages',
  NetworkV2 = 'networkV2',
  HealthDashboard = 'itemHealthDashboard',
  Compliance = 'compliance',
  RiskManagement = 'riskManagement',
}
